import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Sidebar from "../../SideBar";
import axios from "axios";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import HeaderName from "../../HeaderName";
import { API_URL } from "../../../../api/api";
// import { useSelector } from 'react-redux'

function LabServiceRegister() {
  const token = localStorage.getItem("token");
  const url = API_URL();

  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const ID = useLocation().pathname.split("/")[2];
  console.log(ID, "id");

  //Doctor
  const [Doctor, setDoctor] = useState(null);
  const [branch, setBranch] = useState("");
  const [name, setName] = useState("");
  const [special, setSpecial] = useState("");
  const [treatmentUnitMain, setTreatmentUnitMain] = useState("");
  const [commission, setCommission] = useState("");
  const [schedule, setSchedule] = useState("");

  //Therapist
  const [Thera, setTheRa] = useState(null);
  const [tBranch, setTBranch] = useState("");
  const [tName, setTName] = useState("");
  const [tSpecial, setTSpecial] = useState("");
  const [tTreatmentUnitMain, setTTreatmentUnitMain] = useState("");
  const [tCommission, setTCommission] = useState("");
  const [tSchedule, setTSchedule] = useState("");

  //Nurse
  const [Nurse, setNurse] = useState(null);
  const [nBranch, setNBranch] = useState("");
  const [nName, setNName] = useState("");
  const [nSpecial, setNSpecial] = useState("");
  const [nTreatmentUnitMain, setNTreatmentUnitMain] = useState("");
  const [nCommission, setNCommission] = useState("");
  const [nSchedule, setNSchedule] = useState("");

  const [showRelatedDoc, setShowRelatedDoc] = useState(true);
  const [showTherapist, setShowTherapist] = useState(false);
  const [showNurse, setShowNurse] = useState(false);

  const [doctorLists, setDoctorLists] = useState([]);
  const [therapistLists, setTherapistLists] = useState([]);
  const [nurseLists, setNurseLists] = useState([]);

  const [branchLists, setBranchLists] = useState([]);

  const [commissions, setCommissions] = useState("");
  const [activeType, setActiveType] = useState("doctor");

  // const url = 'http://backendcherryk.cherrykmyanmar.com:4000/api'

  const validateCommission = (value) => {
    if (value === "" || value === null) {
      Swal.fire({
        title: "Error",
        text: "Commission is required",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
      return false;
    }

    if (value < 0 || value > 100) {
      Swal.fire({
        title: "Invalid Commission",
        text: "Commission must be between 0 and 100",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
      return false;
    }

    return true;
  };

  const current = Doctor ?? Thera ?? Nurse;
  const type = Doctor ? "Doctor" : Thera ? "Therapist" : Nurse ? "Nurse" : "";

  //Doctor create
  const DoctorCreate = (event) => {
    if (!validateCommission(commission)) return;
    const data = {
      id: ID,
      // name: name,
      // relatedBranch: branch,
      // treatmentUnitMain: treatmentUnitMain,
      // speciality: special,
      // commission: commission,
      // schedule: schedule
    };
    if (commission) {
      data.commissionPercent = commission;
    } else {
      data.commissionPercent = Doctor[0]?.commission;
    }
    if (schedule) {
      data.schedule = schedule;
    } else {
      data.schedule = Doctor[0]?.schedule;
    }

    if (name) {
      data.name = name;
    } else {
      data.name = Doctor[0]?.name;
    }

    if (treatmentUnitMain) {
      data.treatmentUnitMain = treatmentUnitMain;
    } else {
      data.treatmentUnitMain = Doctor[0]?.treatmentUnitMain;
    }
    if (special) {
      data.speciality = special;
    } else {
      data.speciality = Doctor[0]?.speciality;
    }

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("doctor", data, config)
      .then(function (response) {
        // setDoctorLists([...doctorLists, response.data.data])
        Swal.fire({
          title: "Success",
          text: "successfully Registered!",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/doctor");
        // document.getElementById("name").value = "";
        // document.getElementById("com").value = "";
        // document.getElementById("spe").value = "";
        // document.getElementById("unit").value = "";
        // document.getElementById("sche").value = "";
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: "Something Wrong",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  //Therapist create
  const TherapistCreate = (event) => {
    if (!validateCommission(commission)) return;
    const data = {
      id: ID,
      // name: tName,
      // relatedBranch: tBranch,
      // treatmentUnitMain: tTreatmentUnitMain,
      // commission: tCommission,
      // schedule: tSchedule
      // speciality: tSpecial
    };
    if (commission) {
      data.commissionPercent = commission;
    } else {
      data.commissionPercent = therapistLists?.commission;
    }
    if (tSchedule) {
      data.schedule = [tSchedule];
    } else {
      data.schedule = [therapistLists?.schedule];
    }

    if (tName) {
      data.name = tName;
    } else {
      data.name = therapistLists?.name;
    }

    if (tTreatmentUnitMain) {
      data.treatmentUnitMain = tTreatmentUnitMain;
    } else {
      data.treatmentUnitMain = therapistLists?.treatmentUnitMain;
    }
    if (tSpecial) {
      data.speciality = tSpecial;
    } else {
      data.speciality = therapistLists?.speciality;
    }

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("therapist", data, config)
      .then(function (response) {
        // setTherapistLists([...therapistLists, response.data.data])
        Swal.fire({
          title: "Success",
          text: "successfully Registered!",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/doctor");

        // document.getElementById('name').value = ''
        // document.getElementById('com').value = ''
        // document.getElementById('spe').value = ''
        // document.getElementById('unit').value = ''
        // document.getElementById('sche').value = ''
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: "Something Wrong",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  //Nurse
  const NurseCreate = (event) => {
    if (!validateCommission(commission)) return;
    const data = {
      id: ID,
      // name: nName,
      // relatedBranch: nBranch,
      // treatmentUnitMain: nTreatmentUnitMain,
      // commission: nCommission,
      // schedule: nSchedule
      // speciality: nSpecial
    };
    if (nCommission) {
      data.commission = nCommission;
    } else {
      data.commission = Nurse[0]?.commission;
    }
    if (nSchedule) {
      data.schedule = nSchedule;
    } else {
      data.schedule = Nurse[0]?.schedule;
    }
    if (nName) {
      data.name = nName;
    } else {
      data.name = Nurse[0]?.name;
    }

    if (nTreatmentUnitMain) {
      data.treatmentUnitMain = nTreatmentUnitMain;
    } else {
      data.treatmentUnitMain = Nurse[0]?.treatmentUnitMain;
    }
    if (nSpecial) {
      data.speciality = nSpecial;
    } else {
      data.speciality = Nurse[0]?.speciality;
    }

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .put("nurse", data, config)
      .then(function (response) {
        // setNurseLists([...nurseLists, response.data.data])
        Swal.fire({
          title: "Success",
          text: "Successfully Nurse Registered!",
          icon: "success",
          confirmButtonText: "OK",
        });

        // document.getElementById('name').value = ''
        // document.getElementById('com').value = ''
        // document.getElementById('spe').value = ''
        // document.getElementById('unit').value = ''
        // document.getElementById('sche').value = ''
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: "Something Wrong",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const navigate = useNavigate();

  useEffect(() => {
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };

    const getNurseLists = async () => {
      const res = await api.get("nurses");
      console.log(res.data.list, "nur");

      setNurseLists(res.data.list);

      if (res.data.list.filter((el) => el._id === ID)) {
        setNurse(res.data.list.filter((el) => el._id === ID));
        setShowNurse(true);
        setShowRelatedDoc(false);
        setShowTherapist(false);
      }
    };

    getNurseLists();
    // getBranches()
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRes = await api.get(`/doctorById/${ID}`);
        if (docRes.data.data) {
          setDoctor(docRes.data.data);
          return;
        }
      } catch {}

      try {
        const theraRes = await api.get(`/therapistById/${ID}`);
        if (theraRes.data.data) {
          setTheRa(theraRes.data.data);
          return;
        }
      } catch {}

      try {
        const nurseRes = await api.get(`/nurses`);
        const found = nurseRes.data.list.find((el) => el._id === ID);
        if (found) {
          setNurse(found);
        }
      } catch {}
    };

    fetchData();
  }, []);

  console.log(Doctor, "doc");
  console.log(Thera, "thera");
  console.log(Nurse, "nurse");

  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />
        <Sidebar />
        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper">
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/doctor">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active mt-1">Update</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section className="content">
            <div className="container-fluid">
              {/* <!-- Small boxes (Stat box) --> */}
              <div class="card">
                <div class="card-body p-b-0">
                  {/* @if($com == null) */}

                  {/* @csrf */}

                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-4">
                        <label>ReferDoctor</label>
                        <input
                          type="radio"
                          checked={type === "Doctor"}
                          readOnly
                        />
                      </div>

                      <div className="col-md-4">
                        <label>Nurse Aid</label>
                        <input
                          type="radio"
                          checked={type === "Nurse"}
                          readOnly
                        />
                      </div>

                      <div className="col-md-4">
                        <label>Therapist</label>
                        <input
                          type="radio"
                          checked={type === "Therapist"}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  {current && (
                    <>
                      <div className="form-group">
                        <label>Name</label>
                        <input
                          className="form-control"
                          defaultValue={current?.name}
                          onChange={(e) => {
                            if (type === "Doctor") setName(e.target.value);
                            if (type === "Nurse") setNName(e.target.value);
                            if (type === "Therapist") setTName(e.target.value);
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label>Position</label>
                        <input
                          className="form-control"
                          defaultValue={current?.speciality}
                          onChange={(e) => {
                            if (type === "Doctor") setSpecial(e.target.value);
                            if (type === "Nurse") setNSpecial(e.target.value);
                            if (type === "Therapist")
                              setTSpecial(e.target.value);
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label>Treatment Type</label>
                        <input
                          className="form-control"
                          defaultValue={current?.treatmentUnitMain}
                          onChange={(e) => {
                            if (type === "Doctor")
                              setTreatmentUnitMain(e.target.value);
                            if (type === "Nurse")
                              setNTreatmentUnitMain(e.target.value);
                            if (type === "Therapist")
                              setTTreatmentUnitMain(e.target.value);
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label>Commission</label>
                        <input
                          type="number"
                          className="form-control"
                          defaultValue={
                            current?.commission || current?.commissionPercent
                          }
                          onChange={(e) => setCommission(e.target.value)}
                        />
                      </div>

                      <div className="form-group">
                        <label>Joined Date</label>
                        <input
                          type="date"
                          className="form-control"
                          defaultValue={current?.schedule?.[0]}
                          onChange={(e) => {
                            if (type === "Doctor") setSchedule(e.target.value);
                            if (type === "Nurse") setNSchedule(e.target.value);
                            if (type === "Therapist")
                              setTSchedule(e.target.value);
                          }}
                        />
                      </div>

                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          if (type === "Doctor") DoctorCreate();
                          if (type === "Nurse") NurseCreate();
                          if (type === "Therapist") TherapistCreate();
                        }}
                      >
                        {type} Update
                      </button>
                    </>
                  )}
                </div>

                {/* <!-- /.row (main row) --> */}
              </div>
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
          {/* <!-- /.content --> */}
        </div>
        {/* <!-- /.content-wrapper --> */}
        <footer className="main-footer">
          <strong>
            Copyright &copy; 2017-2020{" "}
            <a href="http://www.kwintechnologies.com">K-win Technology</a>.
          </strong>
          All rights reserved.
        </footer>
        {/* <!-- Control Sidebar --> */}
        <aside className="control-sidebar control-sidebar-dark">
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default LabServiceRegister;
